module.exports = __webpack_public_path__ + "static/media/54_A.0b69387e.png";